// @ts-check
import BaseHandler from './BaseHandler';

class DealListPinsHandler extends BaseHandler {
    constructor(mapViewer) {
        super(mapViewer);
        this._data = mapViewer.dragonflyMapData.dealListPinsData;
        this._isMapLoaded = this.map.loaded();
        this._pendingUpdate = undefined;
        // Restore visibility from mapInstance so state survives map reconstruction
        const savedVisible = this.mapInstance._dealListPinsVisible;
        this._isVisible = savedVisible !== false;

        this.setGluBusEvents({
            ACTIVE_DEAL_LIST: this.getVisualReportsFromActiveList,
            VISUAL_REPORTS_LOAD_SUCCESS: this.getVisualReportsFromActiveList,
            VISUAL_REPORTS_FROM_ACTIVE_LIST: this.onVisualReportsFromActiveList,
            DEAL_LIST_PINS_VISIBILITY_UPDATE: this.onPinsVisibilityUpdate,
            MAP_LOAD: this.onMapLoad,
        });
    }

    bind() {
        super.bind();
        this.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
    }

    onMapLoad = e => {
        if (e.source.id !== this.mapInstanceId) return;
        this._isMapLoaded = true;
        if (this._pendingUpdate) {
            this._applyUpdate(this._pendingUpdate);
            this._pendingUpdate = undefined;
        }
    };

    getVisualReportsFromActiveList = () => {
        this.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
    };

    onPinsVisibilityUpdate = ({ mapInstanceId, visible }) => {
        if (mapInstanceId && mapInstanceId !== this.mapInstanceId) {
            return;
        }

        this._isVisible = !!visible;

        if (!this._isVisible) {
            this._applyUpdate({ deals: [], visible: false });
            return;
        }

        this.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
    };

    onVisualReportsFromActiveList = ({ visualReports }) => {
        const payload = {
            deals: Array.isArray(visualReports) ? visualReports : [],
            visible: this._isVisible,
        };

        if (!this._isMapLoaded) {
            this._pendingUpdate = payload;
            return;
        }

        this._applyUpdate(payload);
    };

    _applyUpdate = ({ deals, visible }) => {
        if (!this._data) return;

        this._data.update(deals, visible);

        const { layer, sourceId, layerId } = this._data;

        if (this.map.getLayer(layerId)) {
            this.map.removeLayer(layerId);
        }
        if (this.map.getSource(sourceId)) {
            this.map.removeSource(sourceId);
        }

        if (!layer || !this._data.source) {
            return;
        }

        this.map.addSource(sourceId, this._data.source.source);
        this.map.setLayer(layer);
    };
}

export default DealListPinsHandler;
